// custom typefaces
import 'typeface-montserrat'
import 'typeface-merriweather'
import './src/styles/global.css'
import './src/styles/share.css'
import './src/styles/toggle.css'
